import { gql } from '@apollo/client'

const DELETE_REFERRAL_SUB_SOURCE = gql`
  mutation DELETE_REFERRAL_SUB_SOURCE($referralSubSource: ID!, $moveTo: ID!) {
    deleteReferralSubSource(referralSubSource: $referralSubSource, moveTo: $moveTo) {
      id
    }
  }
`

export default DELETE_REFERRAL_SUB_SOURCE
